import { AccountUnregisteredDialog } from '../account/components/account-unregistered-dialog';
import { ReactivateUsersDialog } from '../admin/admin-panel/account-status-transitions/status-transition-dialogs/reactivate-users-dialog';
import { ApplicationPopUp } from '../application/application-pop-up';
import { EmployedDialog } from '../application/status-transition/employed-dialog';
import { InovaStatusChangeDialog } from '../application/status-transition/inova-status-change-dialog';
import {
  HireStartDateTimeSchedulerDialog,
  InterviewSchedulerDialog,
} from '../application/status-transition/loadable-components';
import { AddEmployeeDialog } from '../employees/loadable-components';
import { EmployeeProfileDialog } from '../employees/profile/employee-profile-dialog';
import { SurveyNotSentWarningDialog } from '../employees/surveys/survey-not-sent-warning-dialog';
import { MergeIntegrationDetailsDialog } from '../merge-integration/merge-integration-details-dialog';
import { QuickbooksConfirmationDialog } from '../quickbooks/quickbooks-confirmation-dialog';

import { ErrorMessageDialog } from '../widgets/error-message-dialog';

export const GLOBAL_DIALOGS = {
  ADD_EMPLOYEE_DIALOG: {
    key: 'addEmployeeDialog',
    component: AddEmployeeDialog,
  },
  EMPLOYED_DIALOG: {
    key: 'employedDialog',
    component: EmployedDialog,
  },
  EMPLOYEE_DIALOG: {
    key: 'employeeDialog',
    component: EmployeeProfileDialog,
  },
  REACTIVATE_USERS_DIALOG: {
    key: 'reactivateUsers',
    component: ReactivateUsersDialog,
  },
  GLOBAL_ERROR: {
    key: 'globalError',
    component: ErrorMessageDialog,
  },
  QUICKBOOKS_CONFIRMATION_DIALOG: {
    key: 'quickbooksConfirmationDialog',
    component: QuickbooksConfirmationDialog,
  },
  SURVEY_NOT_SENT_WARNING: {
    key: 'surveyNotSentWarning',
    component: SurveyNotSentWarningDialog,
  },
  APPLICANT_DIALOG: {
    key: 'applicantDialog',
    component: ApplicationPopUp,
  },
  INTERVIEW_SCHEDULER_DIALOG: {
    key: 'interviewSchedulerDialog',
    component: InterviewSchedulerDialog,
  },
  HIRE_START_DATE_TIME_SCHEDULER_DIALOG: {
    key: 'hireStartDateTimeSchedulerDialog',
    component: HireStartDateTimeSchedulerDialog,
  },
  ACCOUNT_UNREGISTERED_DIALOG: {
    key: 'accountUnregisteredDialog',
    component: AccountUnregisteredDialog,
  },
  // [PROD-3758]: This is a global dialog because the diff viewer loads in all
  // employees for the org on initial opening. This causes the directory
  // component tree to reload which unmounts the MergeIntegrationDetailsDialog
  // and closes both dialogs.  This is planned to become its own page which will
  // eliminate this issue of  the dialog disappearing and in that case we can
  // remove this global dialog
  MERGE_INTEGRATION_DETAILS_DIALOG: {
    key: 'mergeIntegrationDetailsDialog',
    component: MergeIntegrationDetailsDialog,
  },
  // This is a global dialog because we use it in the status transition manager
  // on Accepted status change.
  INOVA_STATUS_CHANGE_DIALOG: {
    key: 'inovaStatusChangeDialog',
    component: InovaStatusChangeDialog,
  },
};
